/**
 * HamburgerIcon - Hamburger-Menü-Icon für die Windows Titlebar
 *
 * Zeigt drei horizontale Linien. Ersetzt das Lucide `Menu` Icon in der Titlebar.
 *
 * @example
 * ```tsx
 * <HamburgerIcon />
 * <HamburgerIcon size={18} />
 * ```
 */
export const HamburgerIcon = ({ size = 16 }: { size?: number }) => {
  const aspectRatio = 11 / 15
  const height = Math.round(size * aspectRatio)

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect className="hamburger-icon__line" x="0" y="0" width="15" height="1.5" rx="0.75" fill="hsl(340, 1%, 41%)" />
      <rect className="hamburger-icon__line" x="0" y="5.25" width="15" height="1.5" rx="0.75" fill="hsl(340, 1%, 41%)" />
      <rect className="hamburger-icon__line" x="0" y="10.5" width="15" height="1.5" rx="0.75" fill="hsl(340, 1%, 41%)" />
    </svg>
  )
}
